import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * GridLayout component for displaying content in a responsive grid
 * Uses semantic color classes from shared configuration
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to display in the grid
 * @param {string} [props.title] - Optional title for the grid
 * @param {number} [props.columns] - Number of columns (default: responsive 1/2/3)
 * @param {string} [props.gap] - Gap between grid items (default: 'gap-6')
 * @param {string} [props.className] - Additional CSS classes
 */
const GridLayout = ({ 
  children, 
  title, 
  columns = null,
  gap = 'gap-6',
  className = '' 
}) => {
  const colors = useColors();
  const semantic = colors.semantic;
  const { replace } = useTextReplacement();

  // Determine grid columns
  const gridCols = columns 
    ? `grid-cols-${columns}` 
    : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';

  return (
    <div className={`container mx-auto mb-6 ${className}`}>
      {title && (
        <h2 className={`text-2xl md:text-3xl font-bold mb-4 ${semantic.sectionHeading}`}>
          {replace(title)}
        </h2>
      )}
      <div className={`grid ${gridCols} ${gap}`}>
        {children}
      </div>
    </div>
  );
};

GridLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  columns: PropTypes.number,
  gap: PropTypes.string,
  className: PropTypes.string,
};

export default GridLayout;

